import { createSlice } from '@reduxjs/toolkit';

export const ItemsSlice = createSlice({
  name: 'items',
  initialState: {
    itemsNums: {},
  },
  reducers: {
    saveAll: (state, action) => {
      const { item, key, value } = action.payload;
      if (!item?._id) {
        return;
      }
      if (item?.__partial && state[item._id] && !state[item._id].__partial) {
        return;
      }
      let clonedItem = { ...item };
      if (key && value) {
        clonedItem[key] = value;
      }

      if (state[item._id]) {
        const previous = state[item._id];
        const nextKeys = Object.keys(clonedItem);
        const prevKeys = Object.keys(previous);
        if (
          nextKeys.length === prevKeys.length &&
          nextKeys.every(field => previous[field] === clonedItem[field])
        ) {
          return;
        }
      }
      state[item._id] = clonedItem;
    },
    saveMany: (state, action) => {
      const { items } = action.payload;
      if (!Array.isArray(items)) {
        return;
      }
      items.forEach(item => {
        if (!item?._id) {
          return;
        }
        if (item?.__partial && state[item._id] && !state[item._id].__partial) {
          return;
        }
        if (state[item._id]) {
          const previous = state[item._id];
          const nextKeys = Object.keys(item);
          const prevKeys = Object.keys(previous);
          if (
            nextKeys.length === prevKeys.length &&
            nextKeys.every(field => previous[field] === item[field])
          ) {
            return;
          }
        }
        state[item._id] = { ...item };
      });
    },
    removeItem: (state, action) => {
      delete state[action.payload];
    },
  },
});

// Action creators are generated for each case reducer function
export const { saveAll, saveMany, removeItem } = ItemsSlice.actions;

export default ItemsSlice.reducer;
